import { CircularProgress, Input, InputLabel, MenuItem, Select, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ConstructionOption } from '../../../../../../types/ObraDetails';
import styles from './constructionSelect.module.scss';

interface Props {
  id: string;
  label: string;
  value?: ConstructionOption;
  options: ConstructionOption[];
  disabled?: boolean;
  error?: boolean;
  plain?: boolean;
  placeholder?: string;
  loading?: boolean;
  loadingLabel?: string;
  notice?: string;
  onChange: (value: ConstructionOption) => void;
}

export default function ConstructionSelect({ id, label, value, options, disabled, error, onChange, plain, placeholder, loading, loadingLabel, notice }: Props) {
  const values = [...new Map((value?.codigo ? [value, ...options] : options)
    .map((option) => [option.codigo, option])).values()];
  return <div className={`${styles.field} ${plain ? styles.plain : ''} ${error ? styles.error : ''}`}>
    <div className={styles.labelRow}>
      <InputLabel id={`${id}-label`} className={styles.label}>{label}</InputLabel>
      {loading ? <CircularProgress size={12} aria-label={loadingLabel} /> : notice &&
        <Tooltip title={notice}><InfoOutlinedIcon tabIndex={0} className={styles.notice} aria-label={notice} /></Tooltip>}
    </div>
    <Select fullWidth variant="standard" id={id} labelId={`${id}-label`} value={value?.codigo || ''}
      disabled={disabled} input={<Input disableUnderline />} displayEmpty
      renderValue={(code) => values.find((option) => option.codigo === code)?.nombre || placeholder || '—'}
      onChange={(event) => {
        const selected = options.find((option) => option.codigo === event.target.value);
        if (selected) onChange(selected);
      }}>
      <MenuItem value="" disabled><div className="menu-item"><span>{placeholder || '—'}</span></div></MenuItem>
      {values.map((option) => <MenuItem key={option.codigo} value={option.codigo} title={option.nombre}>
        <div className="menu-item"><span>{option.nombre}</span></div>
      </MenuItem>)}
    </Select>
  </div>;
}
